import { render, staticRenderFns } from "./PersonalDetailsSec.vue?vue&type=template&id=1781be94&scoped=true&"
import script from "./PersonalDetailsSec.vue?vue&type=script&lang=js&"
export * from "./PersonalDetailsSec.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDetailsSec.vue?vue&type=style&index=0&id=1781be94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1781be94",
  null
  
)

export default component.exports